const user = state => state.user
const isAuthorized = state => Object.prototype.hasOwnProperty.call(state.user, 'id')

export default {
  user,
  isAuthorized
}
